import Box from '@mui/material/Box';

import MobileStepper from '@experimental-components/MobileStepper';

import useStyles from 'components/MenuMakeImport/Stepper/styles';

interface StepperStartProps {
  children: React.ReactNode;
  activeStep: number;
  steps: number;
}

export function StepperStart({ children, activeStep, steps }: StepperStartProps) {
  const classes = useStyles();
  return (
    <Box className={classes.contentBodySteps}>
      {steps && (
        <Box className={classes.contentLinearProgress}>
          <Box width="50%">
            <MobileStepper
              LinearProgressProps={{
                value: Math.ceil((activeStep / steps) * 100),
              }}
              activeStep={activeStep}
              position="static"
              steps={steps}
              variant="progress"
            />
          </Box>

          <Box
            color="#656565"
            fontSize="0.625rem"
            fontWeight={700}
            letterSpacing="0.04em"
          >{`${activeStep} DE ${steps}`}</Box>
        </Box>
      )}

      {children}
    </Box>
  );
}
